

const EVENTCRUDS = [
'ACTION'
]

export const permittedEventCruds = (permissions, screenName) => {
  const foundPermissions = permissions?.filter(permission => {
    return EVENTCRUDS?.find(cruds => {
      if (
        permission?.screens?.screenName?.toLocaleUpperCase() ===
        screenName?.toUpperCase()
      ) {
        return (
          permission?.events?.eventName?.toLocaleUpperCase() ===
          cruds.toUpperCase()
        )
      }
    })
  })
  return foundPermissions
}

const SUBEVENTCRUDS = ['SHARE JOB DETAILS']

export const permittedSubEventCruds = (permissions, screenName) => {
  const foundPermissions = permissions?.filter(permission => {
    return SUBEVENTCRUDS?.find(cruds => {
      if (
        permission?.screens?.screenName?.toLocaleUpperCase() ===
        screenName?.toUpperCase()
      ) {
        return (
          permission?.subEvents?.subEventName?.toLocaleUpperCase() ===
          cruds.toUpperCase()
        )
      }
    })
  })
  return foundPermissions
}

export const crudMatcher = (crud, eventName) => {
  return crud.some(item => item.eventName === eventName)
}

/// future UseCase
export const permittedsCruds = (permissions, screenName) =>
  !permissions?.length
    ? EVENTCRUDS
    : EVENTCRUDS?.filter(cruds => {
        return permissions.find(permission => {
          if (
            (permission?.subEvents != null &&
              permission?.subEvents?.events?.screens?.screenName?.toLocaleUpperCase() ===
                screenName?.toUpperCase()) ||
            permission?.journey?.toUpperCase() === 'INTERNAL'
          ) {
            return (
              permission?.subEvents?.events?.eventName?.toLocaleUpperCase() ===
                cruds.toUpperCase() ||
              permission?.journey?.toUpperCase() === 'INTERNAL'
            )
          } else if (
            permission?.events?.screens?.screenName?.toLocaleUpperCase() ===
              screenName?.toUpperCase() ||
            permission?.journey?.toUpperCase() === 'INTERNAL'
          ) {
            return (
              permission?.events?.eventName?.toLocaleUpperCase() ===
                cruds?.toUpperCase() ||
              permission?.journey?.toUpperCase() === 'INTERNAL'
            )
          }
        })
      })
